var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-help-frame"},[_c('a',{staticClass:"m-help-btn m-btn-icon",attrs:{"href":"https://thought-brand.com/help/","target":"_blank"}},[_c('icon',{attrs:{"i":"help"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }